export default __webpack_public_path__ + "static/media/banda_logos_completa_2.fd7b74da.png";